'use strict';

angular.module('resourceCenterXJRBModule', ['resourceCenterRouterModule']).controller('resCenterXJRBRelCtrl', [
    '$scope',
    '$filter',
    '$q',
    '$state',
    '$stateParams',
    '$timeout',
    'trsHttpService',
    'resCtrModalService',
    'modalDialog',
    'trsspliceString',
    'dateFilter',
    'trsPrintService',
    'storageListenerService',
    'stockApiService',
    'localStorageService',
    'initComDataService',
    'resourceCenterService',
    'stockService',
    '$sessionStorage',
    function(
        $scope,
        $filter,
        $q,
        $state,
        $stateParams,
        $timeout,
        trsHttpService,
        resCtrModalService,
        modalDialog,
        trsspliceString,
        dateFilter,
        trsPrintService,
        storageListenerService,
        stockApiService,
        localStorageService,
        initComDataService,
        resourceCenterService,
        stockService,
        $sessionStorage
    ) {
        initStatus();
        initData();

        /**
         * [initStatus 页面状态初始化]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20, // globleParamsSet.setResourceCenterPageSize,
            };
            $scope.data = {
                items: [],
                casDataArea: [], // 地区的级联数组
                pic: [],
                selectedArray: [],
                doctypeArray: [
                    {
                        value: '',
                        name: '全部',
                    },
                    {
                        value: '1',
                        name: '新闻',
                    },
                    {
                        value: '2',
                        name: '图集',
                    },
                ],
                customConfig: {
                    singleDatePicker: true, // 是否是单选框
                },
                selectedDoctype: {},
                operFlags: [],
                flagTotalItems: [],
                itemCounts: 0, // 显示的稿件数量
                fromdate: '',
                untildate: '',
                tenantId: '',
                curMediaId: '',
                curChanelName: stockService.getSourceName($stateParams.fcode),
                channelTypeArr: { // 列表处的来源，如果后台返回来源字段，则根据fadecode转换为相应的渠道名称
                    baijiahao: '百家号',
                    qie: '企鹅号',
                    toutiao: '头条号',
                    tv: '电视台',
                    broadcast: '广播电台',
                },
            };

            $scope.basicParams = {
                channelName: 'jtcpg',
                typeName: 'jt_lyzh',
                nodeId: $stateParams.fcode,
            };

            $scope.status = {
                currModule: 'xhsg',
                iwoEdit: {
                    1: 'iwonews',
                    2: 'iwoatlas',
                },
                newspaperEdit: {
                    1: 'newspapertext',
                    2: 'newspaperpic',
                },
                websiteEdit: {
                    1: 'websitenews',
                    2: 'websiteatlas',
                },
                unloadover: true, // 图集稿，是否显示加载更多
                isFirstLoad: true, // 首次加载页面（仅全部文字）
                singleGraph: true, // 单图模式：true；多图模式：false
                isCommonList: true, // 是否默认为普通列表展现模式，相对于图片瀑布流模式
                isOpenedPanel: {
                    // 默认展开第一个
                    0: true,
                },
                screenWrapSelected: false, // 默认不展示更多筛选
                labels: [], // 所有标签
                selectedLabels: [], // 当前选中的标签
                multiImgsReady: false, // 多图加载完成
                fcode: $stateParams.fcode,
                ESSearch: false,
                isQuikView: false,
                channelType: $stateParams.fcode,
                btns: 'takedoc,moveToPersonalMaterial,moveToFavorite,more'
            };
            $scope.listParams = stockApiService.getDocListParams();
            $scope.data.keyword = $scope.listParams.keyword;
            $scope.tenanIdParams = stockApiService.getGongGaoTenantIdParam();
            if ($stateParams.fcode !== 'douyin' && $stateParams.fcode !== 'wb'){
                $scope.status.btns += 'quickPreview';
            }
        }

        /**
         * [clearPageData description]清除列表数据
         * @return {[type]} [description]
         */
        function clearPageData() {
            $scope.data.items = [];
            $scope.data.pic = [];
            $scope.data.selectedArray = [];
        }

        /**
         * [initTenantId 获取供稿租户ID（当前环境的新疆日报租户ID）]
         *
         * @return  {[type]}  [return description]
         */
        function initTenantId() {
            let defer = $q.defer();
            let tanantId = localStorageService.get('xjrbTanantId');
            if (tanantId) {
                $scope.data.tenantId = tanantId;
                defer.resolve();
                return defer.promise;
            }
            stockApiService.getGongGaoTenantId($scope.tenanIdParams).then((data) => {
                localStorageService.set('xjrbTanantId', data);
                $scope.data.tenantId = data;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [initData 初始化数据]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.data.selectedDoctype = $scope.data.doctypeArray[0];
            listenStorage();
            if ($scope.status.fcode) {
                $scope.loadingPromise = initDropDown()
                    .then(function() {
                        return initTenantId();
                    })
                    .then(function(){
                        return initProducts();
                    })
                    .then(function() {
                        requestData();
                    });
            }
        }

        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} guid      [description] 稿件id
         * @param  {[type]} flagIndex [description] 类型
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function(guid, flagIndex) {
            var temp = stockService.queryItemBYGUID(guid, $scope.data.operFlags);
            if (!!temp) {
                return stockService.queryItemBYGUID(guid, $scope.data.operFlags).OPERFLAG.substr(flagIndex, 1) === '1';
            } else {
                return false;
            }
        };

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenResource(function() {
                requestData();
                storageListenerService.removeListener('resource');
            }, $scope);
        }

        /**
         * [requestData description]从大数据获取新疆日报成品稿件数据
         * @return {[type]} [description]
         */
        function requestData() {
            clearPageData();
            if ($scope.status.isSzbPage && $scope.status.isSzbBm) {
                requestPreviewData();
            } else {
                dealListParam().then(function(params) {
                    $scope.loadingPromise = stockApiService.getDocList(params).then(function(data) {
                        dealData(data);
                    });
                });
            }
        }

        /**
         * [requestPreviewData description] 请求数字报版面列表
         * @return {[type]} [description]
         */
        function requestPreviewData() {
            var keyword = {
                time: !$scope.data.untildate ? '' : $filter('date')($scope.data.fromdate, 'yyyyMMdd') + ',' + $filter('date')($scope.data.untildate, 'yyyyMMdd'),
                keywords: $stateParams.name,
            };
            var params = stockApiService.getSzbBmListParams();
            params.dataUser = $sessionStorage.get('curUserInfo').TENANTID || '';
            params.pageNum = $scope.page.CURRPAGE;
            params.keyword = JSON.stringify(keyword);
            $scope.loadingPromise = stockApiService.getSzbBmList().then(function(data){
                $scope.data.previewItems = data.content;
                storageListenerService.previewPageTurningStorage($scope.data.previewItems, 'ZB_GUID', 'resourceDetail');
                $scope.page = data.summary_info;
            });
        }

        /**
         * [dealData 处理列表数据]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function dealData(data) {
            var field = data.summary_info.hybaseField;
            let docTypeFiled = {
                FIELDCNNAME: '稿件类型',
                FIELDENNAME: 'DOC_TYPE'
            };
            if ($scope.status.channelType.indexOf('wx, wb, douyin') < 0) {
                field.splice(1, 0, docTypeFiled);
            }
            // 微信渠道去掉栏目和评论数
            $scope.data.headers = $scope.status.channelType !== 'wx' ? field : field.filter(function(item) {
                return ['DOCCHANNEL', 'IR_COMMTCOUNT'].indexOf(item.FIELDENNAME) < 0;
            }); 
            $scope.data.indexName = data.summary_info.indexName;
            for (var i = 0; i < $scope.data.headers.length; i++) {
                if ($scope.data.headers[i].FIELDCNNAME == '来源') {
                    $scope.data.headers[i].FIELDCNNAME =
                        ($scope.status.channelType == 'szb' && '报纸') ||
                        ($scope.status.channelType == 'wz' && '网站') ||
                        ($scope.status.channelType == 'app' && '客户端') ||
                        ($scope.status.channelType == 'wx' && '公众号') ||
                        ($scope.status.channelType == 'website' && '媒体') ||
                        $scope.data.channelTypeArr[$scope.status.channelType] ||
                        '';
                    break;
                }
            }
            $scope.page = data.summary_info;
            if (!$scope.status.hasphoto) {
                $scope.data.items = data.content;
                findReprintCounts();
            } else {
                $scope.data.itemCounts = 0;
                $scope.status.multiImgsReady = false;
                $scope.data.items = $scope.data.items.concat(data.content);
            }
            storageListenerService.previewPageTurningStorage(data.content, 'ZB_GUID', 'resourceDetail');
            getImgList(data.content);
        }

        /**
         * [findReprintCounts description] 获取转载量
         * @return {[type]} [description]
         */
        function findReprintCounts() {
            stockService.findReprintCounts($scope.data.items).then((data) => {
                $scope.data.items = data;
            });
        }

        /**
         * [                                                         description] 请求列表图片
         * @param  {[type]} list [description] 列表数据
         * @return {[type]}      [description]
         */
        function getImgList(list) {
            var docIds = trsspliceString.spliceString(list, 'ZB_GUID', ',');
            if (docIds) {
                let params = stockApiService.getListImgParams();
                params.serviceid = params.channel = $scope.basicParams.channelName;
                params.guids = docIds;
                stockApiService.getListImg(params).then(function(data){
                    dealListImgData(data);
                });
            }
        }

        /**
         * [dealListImgData 处理列表页图片数据]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function dealListImgData(data){
            if (data.result === 'success') {
                if ($scope.status.channelType === 'wb') {
                    for (var key in data.content[0]) {
                        $scope.data.pic[key] = {
                            urlS: [],
                            urlM: [],
                        };
                        for (var i = 0; i < data.content[0][key].IMAGEURLS.length; i++) {
                            $scope.data.pic[key].urlS.push(data.content[0][key].IMAGEURLS[i].urlS);
                            $scope.data.pic[key].urlM.push(data.content[0][key].IMAGEURLS[i].urlM);
                        }
                    }
                } else {
                    var temp = data.content[0];
                    var index = $scope.status.hasphoto ? ($scope.listParams.pageNum - 1) * $scope.listParams.pageSize : 0;
                    for (var j = 0; j < $scope.data.items.length; j++) {
                        var value = $scope.data.items[j];
                        if (!value.imgurl) {
                            value.width = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS[0].wight;
                            value.height = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS[0].height;
                            value.imgurl = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS;
                        }
                    }
                    $scope.status.multiImgsReady = true;
                    for (var k = 0; k < $scope.data.items.length; k++) {
                        if (!$scope.data.items[k].lastLineHide) {
                            $scope.data.itemCounts++;
                        }
                    }
                }
                $timeout(function() {
                    initOperFlag();
                });
            }
        }

        /**
         * [dealListParamForWCM 从大数据获取新疆日报成品稿件数据前处理参数]
         *
         * @return  {[type]}  [return description]
         */
        function dealListParam() {
            let deffer = $q.defer();
            var params = angular.extend({}, $scope.listParams);
            params.fcode = $scope.status.fcode;
            params.pageSize = $scope.page.PAGESIZE;
            params.pageNum = $scope.page.CURRPAGE;
            // eslint-disable-next-line camelcase
            params.media_id = $scope.data.curMediaId;
            params.keyword = JSON.stringify($scope.data.keyword);
            if ($scope.data.tenantId !== '') {
                params.tenantId = $scope.data.tenantId;
                // params.tenantId = 54; // 测试环境调用正式环境数据测试用
                deffer.resolve(params);
            } else {
                stockApiService.getGongGaoTenantId($scope.tenanIdParams).then(function(tenantId) {
                    params.tenantId = tenantId;
                    // params.tenantId = 54; // 测试环境调用正式环境数据测试用
                    deffer.resolve(params);
                });
            }

            return deffer.promise;
        }

        /**
         * [pageChanged description]分页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            requestData();
        };

        /**
         * [selectAll 全选]
         *
         * @return  {[type]}  [return description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc 单选]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         * [initDropDown description] 下拉框初始化
         * @return {[type]} [description]
         */
        function initDropDown() {
            var defer = $q.defer();
            // 全部稿件
            $scope.docType = {
                data: initComDataService.newsType(),
                curValue: initComDataService.newsType()[0],
            };
            // 检索字段
            $scope.keyType = {
                data: initComDataService.searchBigdataType(),
                curValue: initComDataService.searchBigdataType()[0],
            };
            // 所有主题
            let themeParams = stockApiService.getThemeTypeParams();
            stockApiService.getThemeType(themeParams).then(function(themeData) {
                $scope.themeType = {
                    data: [{ dictName: '所有主题', id: '' }].concat(themeData),
                    curValue: { dictName: '所有主题', id: '' },
                };
                defer.resolve();
            });

            return defer.promise;
        }

        /**
         * [initProducts 初始化栏目信息]
         *
         * @return  {[type]}  [return description]
         */
        function initProducts(){
            let defer = $q.defer();
            let productParam = stockApiService.getProductParams();
            productParam.fcode = $scope.status.fcode;
            productParam.tenantId = $scope.data.tenantId.replace(/\"/g, '');
            stockApiService.getProduct(productParam).then(function(productData){
                $scope.product = {
                    data: [{ name: '所有' + $scope.data.curChanelName, media_id: '' }].concat(productData.content),
                    curValue: { name: '所有' + $scope.data.curChanelName, media_id: '' },
                };
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [filterName 处理客户端名字]
         *
         * @param   {[type]}  title  [title description]
         *
         * @return  {[type]}         [return description]
         */
        // $scope.filterName = function(title) {
        //     if (typeof title === 'string' && title.indexOf('客户端') > -1) {
        //         return title.replace('客户端', '');
        //     } else {
        //         return title;
        //     }
        // };

        /**
         * [viewBigDataInfo 取签见撤重]
         *
         * @param   {[type]}  ChnlDocId   [ChnlDocId description]
         * @param   {[type]}  showRepeat  [showRepeat description]
         * @param   {[type]}  showClick   [showClick description]
         *
         * @return  {[type]}              [return description]
         */
        $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick) {
            var operFlags = stockService.queryItemBYGUID(ChnlDocId, $scope.data.operFlags).OPERFLAG;
            var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
            event.stopPropagation();
        };

        /** --------- 稿件操作开始 --------- */
        /**
         * [openTakeDraftModal description]取稿
         * @return {[type]} [description]
         */
        $scope.openTakeDraftModal = function() {
            if (!$scope.data.selectedArray.length) {
                modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                return;
            }
            if (!selectedSingleDoctype()) {
                modalDialog.alertType('批量取稿只允许选择一种稿件类型', '', 'error', 'confirm', function () { });
                return;
            }
            var params = stockApiService.getTakeDocParams();
            params = dealOperPublicParams(params);
            var isOnlyOne = !($scope.data.selectedArray.length > 1);
            var modalInstance = resCtrModalService.fullTakeDraft(params, isOnlyOne, $scope.data.selectedArray);
            modalInstance.result.then(
                function(data) {
                    takeDraftDownloadImgs(data).then(function() {
                        initOperFlag();
                    });
                },
                function() {
                    initOperFlag();
                }
            );
        };


        /**
         * [selectedDoctype description] 判断选中稿件是否属于同一类型openTakeDraftModal
         * @return {[type]} [description]
         */
        function selectedSingleDoctype() {
            var doctype = parseInt($scope.data.selectedArray[0].DOC_TYPE);
            for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                if (doctype !== parseInt($scope.data.selectedArray[i].DOC_TYPE)) {
                    return false;
                }
            }
            return true;
        }

        /**
         * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function takeDraftDownloadImgs(data) {
            var deferred = $q.defer();
            var needDownloadImg = false;
            for (var i = 0; i < data.REPORTS.length; i++) {
                if (data.REPORTS[i].PICERROR == 1) {
                    needDownloadImg = true;
                    break;
                }
            }
            if (needDownloadImg) {
                resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        /**
         * [CreationAxis 取至个人素材]
         *
         * @return  {[type]}  [return description]
         */
        $scope.creationAxis = function() {
            if (!$scope.data.selectedArray.length) {
                modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                return;
            }
            var params = angular.copy($scope.basicParams);
            params.guid = trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ',');
            $scope.operPromise = resourceCenterService.setBigDataCreation(params).then(function(data) {
                modalDialog.alertType('添加成功', '', 'success', false);
                $scope.data.selectedArray = [];
            }, function(){
                console.log('aaa');
            });
        };

        /**
         * [printbtn description] 打印
         * @return {[type]} [description]
         */
        $scope.printBtn = function() {
            if (!$scope.data.selectedArray.length) {
                modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                return;
            }
            var params = {
                serviceid: 'jtcpg',
                modelid: 'detailData',
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                channelName: $scope.basicParams.channelName,
                typeid: 'zyzx',
                indexName: $scope.page.indexName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                trsPrintService.trsPrintBigData(data);
            });
        };

        /**
         * [canCollect description]判断能否收藏
         *
         * @return  {[type]}  [return description]
         */
        function canCollect() {
            return $scope.data.selectedArray.some(function(item) {
                return item.DOC_TYPE != 1 && item.DOC_TYPE != 2 && item.DOC_TYPE != 7 && item.DOC_TYPE != 4;
            });
        }

        /**
         * [collect description] 收藏
         * @return {[type]} [description]
         */
        $scope.collect = function() {
            if (!$scope.data.selectedArray.length) {
                modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                return;
            }
            if (canCollect()) {
                modalDialog.alertType('只能收藏新闻、图集、视频或者链接稿', '', 'warning', 'confirm', '');
                return;
            }
            var params = stockApiService.getCollectParams();
            params = dealOperPublicParams(params);
            $scope.operPromise = stockApiService.collect(params).then(function(data){
                modalDialog.alertType('收藏成功!', '', 'success', false, function() {
                    $scope.data.selectedArray = [];
                });
            }, function(data){
                console.log(data);
            });
        };

        /**
         * [dealOperPublicParams 稿件操作公共参数处理]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function dealOperPublicParams(params){
            params.guid = trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ',');
            params.indexname = $scope.page.indexName;
            params = angular.extend(params, $scope.basicParams);
            return params;
        }

        /**
         * [export description] 导出
         * @return {[type]} [description]
         */
        $scope.export = function() {
            if (!$scope.data.selectedArray.length) {
                modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                return;
            }
            var params = {
                serviceid: 'mlf_exportword',
                methodname: 'exportBigDataDocs',
                GUIDS: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                CHANNELNAMES: $scope.basicParams.channelName,
                indexName: $scope.page.indexName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
            });
        };

        /**
         * [initOperFlag description] 初始化取签见撤重
         * @return {[type]} [description]
         */
        function initOperFlag() {
            stockService.initOperFlag($scope.status.fcode, $scope.data.items).then(function(data){
                $scope.data.operFlags = data;
            });
            $scope.data.selectedArray = [];
        }

        /** --------- 稿件操作结束 --------- */

        /**
         * [showSelectedArea description] 数据地域信息的级联菜单获取数据
         * @param  {[type]} node [description] 当前节点
         * @return {[type]}      [description]
         */
        $scope.showSelectedArea = function(node) {
            var deffer = $q.defer();
            resourceCenterService.getArea(node).then(function (data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        };

        /**
         * [searchWithKeyword description] 根据条件筛选稿件
         * @param  {[type]} key   [description] 筛选类型
         * @param  {[type]} value [description] 筛选内容
         * @return {[type]}       [description]
         */
        $scope.searchWithKeyword = function (key, value) {
            if (key == 'time') {
                value = $scope.data.untildate ? $filter('date')($scope.data.fromdate, 'yyyy-MM-dd') + ',' + $filter('date')($scope.data.untildate, 'yyyy-MM-dd') : ''; // $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() ? $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() + "," + $filter('date')($scope.data.untildate, 'yyyy/MM/dd').toString() : "";
            } else if (key == 'area') {
                $scope.data.area = angular.copy(value);
                value = value[0][value.length - 1].id;
            }
            $scope.data.keyword[key] = value;
            if (key == 'menuscriptType' && value != '2') {
                $scope.status.hasphoto = false;
            } else if (key == 'menuscriptType' && value == '2') {
                $scope.status.hasphoto = true;
            }
            $scope.data.keyword.searchType = $scope.keyType.curValue.value;
            $scope.listParams.pageNum = $scope.page.CURRPAGE = 1;
            $scope.data.items = [];
            requestData();
        };

        /**
         * [getListByMedia 获取某个产品下的文章列表]
         *
         * @param   {[type]}  mediaId  [mediaId description]
         *
         * @return  {[type]}           [return description]
         */
        $scope.getListByMedia = function(mediaId){
            // eslint-disable-next-line camelcase
            $scope.data.curMediaId = mediaId;
            requestData();
        };

        /**
         * [quickPreview description] 快速预览模式
         * @return {[type]} [description]
         */
        $scope.quickPreview = function () {
            $scope.$root.filterData = {
                page: $scope.page, // 分页
                fromdate: $scope.data.fromdate, // 开始时间
                untildate: $scope.data.untildate, // 结束时间
                paramsKeyword: $scope.data.keyword, // 其他条件
                area: $scope.data.area, // 地域信息
                docType: $scope.docType, // 当前稿件类型
                themeType: $scope.themeType, // 当前主题
                keyType: $scope.keyType, // 当前检索信息
                product: $scope.product.curValue // 当前产品
            };
            if ($scope.status.hasphoto) { // 是否图集稿，是则直接传递图集列表数据
                $scope.$root.filterData.listData = $scope.data.items;
                $scope.$root.filterData.singleGraph = $scope.status.singleGraph; // 是否单图
            }
            $state.go('front.resourcectrl.xjrb.quickpreview', $stateParams);
        };

        /**
         * [jsonToArray description] 将json转换成对象,因为抖音某块后台返回的数据中IR_VIEDO_URL为json格式,不能转换
         * @param   {[type]}  item  [item description] 列表数据中的IR_VIEDO_URL字段
         */

        $scope.jsonToArray = function (item) {
            item.IR_VIEDO_URL = JSON.parse(item.IR_VIEDO_URL);
        };

        /**
         * [openUrl description] 微博-查看原微博
         * @param  {[type]} url [description]
         * @return {[type]}     [description]
         */
        $scope.openUrl = function(url) {
            window.open(url);
        };

        /**
         * [openPageForSearch description] 打开高级检索新页面
         * @return {[date]} [description]
         */
        $scope.openPageForSearch = function() {
            var url = $state.href('resadvancedsearch');
            window.open(url, '_blank');
        };
        $scope.videoPreview = function(item) {
            window.open(item.PUBURL);
        };
    },
]);
